<template>
  <div>
    <Row type="flex" justify="center">
      <Col :span="16">
        <div :span="24" style="background:#ddd;font-size:25px;border-top-left-radius:15px;border-top-right-radius:15px;">
          <span style="margin-left:25px;font-weight:bold;">我的银行卡</span>
        </div>
        <div class="box">
          <Row type="flex">
            <Col :span="5" v-for="(card,i) in cardList" :key="i" style="margin:12px;width:220px;height:130px;margin-left:27px;">
              <div class="bank_card_box" @click="unbounding(card,i)" v-bind:class="{bandColor1:true,bandColor2:rowNo===i?true:false}">
                <div class="bank_name" v-model="form.bankid" style="width:150px;text-align:center;">
                  <div style="background:#dddee1;height:40px;line-height:40px;text-align:center;font-size:18px;font-weight:bold;">
                    <span v-if="card.name == null">{{card.name}}</span>
                    <span v-if="card.name != null">{{`${card.name.slice(0,6)}**`}}</span>
                  </div>
                </div>
                <div class="ivu-tooltip-content" style="display:flex;">
                  <span style="font-size:15px;margin-top:15px;">尾号{{card.cardNo | cardSlice}}</span>
                  <div style="background:#7DAECB;margin-top:15px;width:40px;height:20px;color:#ffffff;margin-left:5px;text-align:center;border-radius: 10%">{{card.bankType === '对公'?'对公':'对私'}}</div>
                </div>
              </div>
            </Col>
            <Col :span="5">
              <div class="bank_card_box bank_card_box1" @click="()=>{this.$router.push({name:'addBankCard'})}">
                <Icon type="plus" color="#999" size="40"></Icon>
                <div style="margin-top: 10px;padding-bottom: 12px">添加银行卡</div>
              </div>
            </Col>
            <Col style="margin-left:82%;width:100px;font-size:20px;color:green;cursor: pointer;">
              <div @click="unbind(card)">管理银行卡</div>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  </div>
</template>
<script>
  import ApiClient from '@/api/ApiClient'
  import MyButton from '@/components/MyButton'
  import passwordInput from '@/components/passwordInput'
  export default {
    components: {MyButton, passwordInput},
    name: "myBankCards",
    data() {
      const validateCardNo = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please enter your carNo again'));
        }if (value !== this.form.cardNo) {
          callback(new Error('The two input carNo do not match!'));
        } else {
          callback();
        }
      };
      return {
        value: '',
        modal2: false,
        cardList: [],
        rowNo:'',
        branchBank:[],
        balance: null,
        card: {
          bankName: '',
          cardNo: '',
          bankType:''
        },
        form: {
          amount: '',
          bankName: '',
          cardNo: '',
          cashPassword: '',
          customerName: '',
          type: '对公',
        },
        amount: [
          {pattern: '^[0-9]+(.[0-9]{1,2})?$', required: true, message: '请输入数字', trigger: 'blur'}
        ],
        require1:[{ required: true, message: '不能为空', trigger: 'blur'}],
        require2:[{ pattern: '^[0-9]*$',required: true, message: '输入不正确', trigger: 'blur',min:9}],
        cardNo1:[{ validator: validateCardNo,required: true, message: '两次输入的卡号不一致', trigger: 'blur'}],
        serviceCharge:null,
      }
    },
    methods: {
      initData() {
        ApiClient.post('/desktop/profile/cardQuery.do', {size: 9999, page: 1}).then(data => {
          this.cardList = data.wCardQueryDataDtoList;
          this.card = this.cardList[0];
          this.form.cardNo = this.card.cardNo;
        });
      },
      unbounding(card,i) {
        this.form.amount=card.amount;
        this.form.bankName=card.bankName;
        this.form.cardNo=card.cardNo;
        this.form.cashPassword=card.cashPassword;
        this.form.customerName=card.customerName;
        this.rowNo = i;
      },
      unbind(card) {
        if(!this.cardList[0]){
          this.$Message.error('请先添加银行卡')
        }else{
          this.$router.push({name:'unbundingBankCard', query: card})
        }
      },
    },
    computed:{
      computedAmount(){
        if(this.form.amount > 0){
          return `${Number(this.form.amount - this.serviceCharge).toFixed(2)}`
        }else{
          return '0.00'
        }
      }
    },
    mounted() {
      this.initData();
    },
  }
</script>
<style scoped lang="less">
  .box {
    border: 1px solid #999;
    margin-bottom: 20px;
    .large_font{
      font-size: 16px;
    }
    .box_left {
      float: left;
    }
    .box_right {
      float: right;
      cursor: pointer;
      margin:16px 0;
    }
    .card_no {
      font-size: 15px
    }
    margin-bottom: 20px;
  }
  .balance {
    color: #666;
    font-size: 30px;
    font-weight: 600;
  }
  .bank_card_box {
    border: 1px solid #ccc;
    border-radius: 3px;
    background-color: #EFF0F1;
    padding: 10px;
    cursor: pointer;
    width: 85%;
    margin-bottom: 20px;
    height:105px;
  }

  .bank_card_box1 {
    text-align: center;
    cursor: pointer;
    height:103px;
    margin-left:40px;
    margin-top:10px;
    width:190px;
    border:1px solid #999;
  }
  .bandColor1{
    border:2px solid #ddd;
    margin: 0 auto;
    display: block;
  }
  .bandColor2{
    border:2px solid #228b22;
  }
</style>
<style lang="less">
  .input {
    display: inline-block;
    &:last-child {
      border-right: 1px solid #999;
    }
    input {
      border-top: 1px solid #999;
      border-bottom: 1px solid #999;
      border-left: 1px solid #999;
      width: 45px;
      height: 45px;
      outline: none;
      font-family: inherit;
      font-size: 28px;
      font-weight: inherit;
      text-align: center;
      line-height: 45px;
      color: #c2c2c2;
      background: rgba(255, 255, 255, 0);
    }
  }
  .withdraw .ivu-form-item-label{
    font-size: 14px!important;
  }

</style>




// WEBPACK FOOTER //
// src/pages/myProfile/myBankCards.vue